import { useState } from 'react';
import { ILamThuBay } from '@/services/LamThuBay';
import {
  confirmLamThuBay,
  createLamThuBay,
  getAllLop,
  getLop,
  getLamThuBay,
  updateLamThuBay,
} from '@/services/LamThuBay/lamthubay';
import moment from "moment-timezone";

export default () => {
  const [danhSach, setDanhSach] = useState<ILamThuBay.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<ILamThuBay.Record>({} as any);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({ thang: moment().month(), nam: moment().year() });
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [dataLop, setDataLop] = useState<ILamThuBay.DataLop[]>([]);
  const [dataView, setDataView] = useState<ILamThuBay.DataReq | ILamThuBay.Record>();
  const [view, setView] = useState<boolean>(false);
  const [dateValue, setDate] = useState<any>(moment());
  const getDataLamThuBay = async (donViId?: string) => {
    setLoading(true);
    const res = await getLamThuBay({ page, limit, cond: { ...cond, truongId: donViId } });
    if (res) {
      setDanhSach(res?.data?.data?.result);
      setTotal(res?.data?.data?.total);
    }
    setLoading(false);
  };
  const getDataLopModel = async (truongId: string) => {
    setLoading(true);
    const res = await getAllLop({ donViId: truongId, cond });
    if (res) {
      setDataLop(res?.data?.data?.result);
    }
    setLoading(false);
  };
  const confirmLamThuBayModel = async (id: string, trangThai: string) => {
    setLoading(true);
    const res = await confirmLamThuBay(id, trangThai);
    if (res) {
    }
    setLoading(false);
  };
  const createLamThuBayModel = async (data: ILamThuBay.DataReq) => {
    setLoading(true);
    const res = await createLamThuBay(data);
    if (res) {
    }
    setLoading(false);
  };
  const updateLamThuBayModel = async (id: string, data: ILamThuBay.DataReqUpdate) => {
    setLoading(true);
    const res = await updateLamThuBay(id, data);
    if (res) {
    }
    setLoading(false);
  };
  return {
    danhSach,
    record,
    setRecord,
    loading,
    setLoading,
    total,
    setTotal,
    page,
    limit,
    setPage,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    visibleForm,
    edit,
    setEdit,
    getDataLamThuBay,
    confirmLamThuBayModel,
    dataLop,
    getDataLopModel,
    createLamThuBayModel,
    dataView,
    setDataView,
    view,
    setView,
    updateLamThuBayModel,
    setDate,dateValue
  };
};
